'use client'

import { ChaineLogo } from '@chain-zen/ui'

import { LoginForm } from './login-form'

export function LoginPageClient() {
  return (
    <>
      <ChaineLogo size="md" data-testid="chaine-logo" />

      <div className="space-y-2 md:space-y-3 text-left md:text-center">
        <h1 className="text-3xl md:text-3xl font-semibold tracking-tight" data-testid="login-heading">
          Your logistics operations,{' '}
          <span className="text-transparent bg-gradient-to-r from-gradient-rose via-gradient-pink to-gradient-purple bg-clip-text will-change-transform">
            reimagined.
          </span>
        </h1>
        <p className="text-md text-gray-600 dark:text-gray-300 font-normal" data-testid="login-subheading">
          Enter your email address or phone number to get started.
        </p>
      </div>

      <LoginForm />

      <div className="space-y-4">
        <p className="text-sm text-gray-500 dark:text-gray-400 text-center">
          By continuing, you agree to our{' '}
          <a
            href="https://chaineapp.com/terms"
            className="font-medium underline"
            data-testid="terms-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Service
          </a>{' '}
          and{' '}
          <a
            href="https://chaineapp.com/privacy"
            className="font-medium underline"
            data-testid="privacy-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
        </p>
      </div>
    </>
  )
}
